var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuditoriaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.32 523.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "auditoria") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354,295.09a23.35,23.35,0,0,0-23.33,23.34v134.4H74v-350h93.34a23.34,23.34,0,0,0,0-46.67H74a46.67,46.67,0,0,0-46.66,46.67v350A46.67,46.67,0,0,0,74,499.49H330.65a46.67,46.67,0,0,0,46.67-46.66V318.43A23.35,23.35,0,0,0,354,295.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M490.25,351.56l-77.7-119.23h0a116.66,116.66,0,1,0-81.9,33.83,114.42,114.42,0,0,0,42.93-8.4l77.47,119.46a23.43,23.43,0,0,0,39.2-25.67ZM260.65,149.49A70,70,0,1,1,281.16,199,70,70,0,0,1,260.65,149.49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.65,359.49H144a23.34,23.34,0,0,0,0,46.67H260.65a23.34,23.34,0,0,0,0-46.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.65,266.16H144a23.34,23.34,0,0,0,0,46.67H260.65a23.34,23.34,0,0,0,0-46.67Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditoriaIcon);
export default __webpack_public_path__ + "static/media/auditoriaIcon.e3e76f9233fef58c89e674e8cdd01062.svg";
export { ForwardRef as ReactComponent };